export default {"src":"/_next/static/image/src/images/our-food/carrots.d9589385127ae6dbaffc928453177d46.svg","height":39,"width":91};